/* eslint-disable */
export default {
  title: 'Audio',
  input: 'Input',
  microphone: 'Microfono',
  autoAdjustMicLevel: 'Regola automaticamente livello microfono',
  output: 'Output',
  speakerSource: 'Sorgente altoparlante',
  speakerVolume: 'Volume altoparlante',
  ringtoneSource: 'Sorgente suoneria e notifica',
  ringtoneVolume: 'Volume suoneria e notifica',
  ringtones: 'Suonerie',
  noDevices: 'Nessun dispositivo',
  off: 'Off',
  noLabel: 'Dispositivo sconosciuto',
  stopRecordDescription:
    'Parla per controllare il livello del microfono ({countDown} sec)',
  stopPlaybackDescription: 'Riproduzione della registrazione in corso…',
  startRecordButton: 'Verifica microfono',
  stopRecordButton: 'Interrompi registrazione',
  stopPlaybackButton: 'Interrompi verifica',
  startTestButton: 'Verifica altoparlante',
  stopTestDescription: 'Riproduzione di un suono campione in corso...',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"input"@#@ @source: @#@"Input"@#@
// @key: @#@"microphone"@#@ @source: @#@"Microphone"@#@
// @key: @#@"autoAdjustMicLevel"@#@ @source: @#@"Automatically adjust my mic level"@#@
// @key: @#@"output"@#@ @source: @#@"Output"@#@
// @key: @#@"speakerSource"@#@ @source: @#@"Speaker source"@#@
// @key: @#@"speakerVolume"@#@ @source: @#@"Speaker volume"@#@
// @key: @#@"ringtoneSource"@#@ @source: @#@"Ringtone and notification source"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone and notification volume"@#@
// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"noDevices"@#@ @source: @#@"No devices"@#@
// @key: @#@"off"@#@ @source: @#@"Off"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"stopRecordDescription"@#@ @source: @#@"Say something to check your mic level ({countDown} sec)"@#@
// @key: @#@"stopPlaybackDescription"@#@ @source: @#@"Playing your recording..."@#@
// @key: @#@"startRecordButton"@#@ @source: @#@"Test microphone"@#@
// @key: @#@"stopRecordButton"@#@ @source: @#@"Stop recording"@#@
// @key: @#@"stopPlaybackButton"@#@ @source: @#@"Stop test"@#@
// @key: @#@"startTestButton"@#@ @source: @#@"Test speaker"@#@
// @key: @#@"stopTestDescription"@#@ @source: @#@"Playing sample sound..."@#@
